import React from "react";
import { Button, Column, Columns, Input, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import {readableDate} from "../../utils";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";



export default function ConfirmModal({onConfirm, movement, show, setShow, onTrackingOptionChange, trackingOptions, onChange}){



    const validator = (movement) => {
        if(!!movement.tracking_option){
            return true
        }
        return false
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            closeOnBlur
            active={show}
            onClose={() => setShow(false)}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{ backgroundColor: "white" }}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Complete Movement</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Movement Number</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.id}
                            />
                        </Column>
                        <Column>
                            <label className="label">Department Creator</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.department ? movement.department.name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Vehicle To Move</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.vehicle}
                            />
                        </Column>
                        <Column>
                            <label className="label">Start Address</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.start_address}
                            />
                        </Column>
                        <Column>
                            <label className="label">End Address</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.end_address}
                            />
                        </Column>
                        <Column>
                            <label className="label">Delivery Date</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={readableDate(movement.delivery_date)}
                            />
                        </Column>
                        <Column>
                            <label className="label">Miles</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.miles}
                            />
                        </Column>
                        <Column>
                            <label className="label">Rate</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.movement_rate ? movement.movement_rate.name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Customer Cost</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.cost}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Department Charger</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.movement_performer ? movement.movement_performer.name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Vehicle User For Movement</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.vehicle_used ? movement.vehicle_used.registration : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Type</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.movement_type ? movement.movement_type.name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Driver</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.driver ? movement.driver.name : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Internal Charge</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={movement.internal_charge}
                            />
                        </Column>

                        <Column/>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <TrackingOptionsPicker
                                name={"tracking_option"}
                                options={trackingOptions}
                                editable={true}
                                label={"Tracking Option"}
                                value={movement.tracking_option}
                                onChange={onTrackingOptionChange}
                                disabled={false}
                                inlineEdit={false}
                                blank={true}
                                className={"y"}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={() => onConfirm(movement)}
                                disabled={!validator(movement)}
                                isFullWidth
                            >
                                Complete
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"danger"}
                                onClick={() => setShow(false)}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );
}